import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'common/stores/user-auth/user-auth.constants';

const BROWSER_SESSION_COOKIE_KEY = 'EIQ_AUTH_BROWSER_SESSION';

class AuthSessionService {
  start(accessToken: string, refreshToken: string) {
    document.cookie = `${BROWSER_SESSION_COOKIE_KEY}=active; ${this.getCookieAttributes()}`;

    if (!this.isActive()) {
      this.clearStoredTokens();
      return;
    }

    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }

  isActive() {
    return document.cookie.split(';').some((cookie) => cookie.trim().startsWith(`${BROWSER_SESSION_COOKIE_KEY}=`));
  }

  getAccessToken() {
    return this.getToken(ACCESS_TOKEN_KEY);
  }

  getRefreshToken() {
    return this.getToken(REFRESH_TOKEN_KEY);
  }

  setAccessToken(accessToken: string) {
    if (!this.isActive()) {
      this.clearStoredTokens();
      return;
    }

    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }

  clear() {
    this.clearStoredTokens();
    document.cookie = `${BROWSER_SESSION_COOKIE_KEY}=; ${this.getCookieAttributes()}; Max-Age=0`;
  }

  private getToken(key: string) {
    if (!this.isActive()) {
      this.clearStoredTokens();
      return null;
    }

    return localStorage.getItem(key);
  }

  private clearStoredTokens() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

  private getCookieAttributes() {
    const secureAttribute = window.location.protocol === 'https:' ? '; Secure' : '';
    return `Path=/; SameSite=Strict${secureAttribute}`;
  }
}

const authSessionService = new AuthSessionService();

export default authSessionService;
